import { render, staticRenderFns } from "./VaCollapse.demo.vue?vue&type=template&id=5cb55400&"
import script from "./VaCollapse.demo.vue?vue&type=script&lang=js&"
export * from "./VaCollapse.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports